<template>
  <dict-select
    :value="value"
    :placeholder="$l('form_placeholder_tskTimeZone')"
    url="/master/common/dict/biz"
    :body="{ dictType: 'meetingTimeZone' }"
    :size="size"
    clearable
    filterable
    @loaded="loaded"
    @change="change"
  />
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    size: { type: String, default: '' },
  },
  data() {
    return { localTimeZone: '' }
  },
  methods: {
    async loaded(val) {
      if (!val?.length || this.value) return

      const localTimeZone = await this.loadLocalTimeZone()
      const item = val.find((item) => item.value === localTimeZone)
      if (!item) return

      this.$emit('input', localTimeZone)
      this.$emit('update:value', localTimeZone)
    },
    change(val) {
      this.$emit('change', val)
      this.$emit('input', val)
      this.$emit('update:value', val)
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
  },
}
</script>
